import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { plainToClass } from 'class-transformer';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';

import { PaymentModel } from 'app/shared/models/payment.model';

/**
* This is a service for payment management.
*/
@Injectable()
export class PaymentService {
    constructor(private requestService: ObservableRequestService) { }

    @Output()
    updatePaymentsListsEmitter:EventEmitter<string> = new EventEmitter();

    deletePayment(paymentId: number): Observable<any> {
        return this.requestService.deleteRequest(ConstantsService.DELETE_PAYMENT,
            this.requestService.serialize({paymentId : paymentId}),
            this.requestService.getFormEncodedContentType());
    }

    emitUpdatePaymentLists() {
        this.updatePaymentsListsEmitter.emit();
    }

    getPaymentsList(status): Observable<any> {
        const fetchPaymentsURL = ConstantsService.FETCH_PAYMENTS + '/' + status;
        return this.requestService.getRequest(fetchPaymentsURL)
            .map(response => {
                return plainToClass(PaymentModel, response.arrResult as Object);
            });
    }

    savePayment(body: Object): Observable<any> {
        return this.requestService
            .postRequest(ConstantsService.SAVE_PAYMENT,
            JSON.stringify(body),
            this.requestService.getJSONContentType());
    };
}



// WEBPACK FOOTER //
// ./src/app/finance/payments/payment.service.ts